import Axios from "axios";

const client = Axios.create();
export default client;